import { countries } from "./countryList.js";

// cities: https://prod.greatescape.co/api/flights/cities
// geo: https://prod.greatescape.co/api/travel/geo

export function getCountryList() {
  return countries.toSorted((a, b) => {
    if (a?.name > b?.name) return 1;
    if (b?.name > a?.name) return -1;
    return 0;
  });
}

export function getCountryInfo(code) {
  let country;
  countries.forEach((item) => {
    if (item.code === code) {
      country = item;
    }
  });

  return country;
}
